module.exports = __webpack_public_path__ + "img/158.6a2c88e2.jpg";